import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { setError } from '../../Error/actions';
export function setServices(services) {
  return {
    type: 'SET_SERVICES',
    services: services
  };
}
export function deleteOrganizationsRefuse(idOrganization, idService) {
  return {
    type: 'DELETE_ORGANIZATION',
    idService: idService,
    idOrganization: idOrganization,
    entityType: 'organizations'
  };
}
export function getServices(cookies) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: 'users/me/services',
      credentials: cookies,
      method: 'GET',
      onSuccess: function onSuccess(_ref) {
        var data = _ref.data;
        return Promise.all([dispatch(setServices(data))]);
      },
      onError: function onError() {
        return Promise.all([dispatch(setError({
          code: 404,
          message: 'Error al cargar los servicios'
        }))]);
      }
    });
  };
}
export function setOrganizationsRefuse(idOrganization, idService) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/services/".concat(idService, "/organizations/").concat(idOrganization),
      credentials: true,
      method: 'DELETE',
      onSuccess: function onSuccess() {
        return Promise.all([dispatch(deleteOrganizationsRefuse(idOrganization, idService))]);
      },
      onError: function onError() {
        return Promise.all([dispatch(setError({
          code: 404,
          message: 'Error al cargar los servicios'
        }))]);
      }
    });
  };
}